export type SpriteIndex = {
  latestUpdated: string | number | null;
  total: number;
  records: any[];
  ts: number;
};

const KEY = 'spriteIndex:v1';

export function loadIndex(userId?: string): SpriteIndex | null {
  if (!userId) return null;
  try {
    const raw = sessionStorage.getItem(`${KEY}:${userId}`);
    return raw ? JSON.parse(raw) as SpriteIndex : null;
  } catch { return null; }
}

export function saveIndex(userId: string | undefined, data: Omit<SpriteIndex,'ts'>) {
  if (!userId) return;
  try {
    sessionStorage.setItem(`${KEY}:${userId}`, JSON.stringify({ ...data, ts: Date.now() }));
  } catch {}
}